import { ScrollView, Text } from 'react-native'

export default function Page() {
  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic">
      <Text>活跃查询</Text>
    </ScrollView>
  )
}
